<!-- Stripe-->

<div>
  <form novalidate (ngSubmit)="buyPlan()" [formGroup]="stripeTest">
    <input type="text" formControlName="name" placeholder="{{ 'PLAN.CC_CARD_NAME' | translate }}">
    <div id="card-element" class="field"></div>
    <button type="submit">
      {{ 'MAP.PHOTOGRAM.PAYMENT' | translate }}
    </button>
  </form>

</div>

<!--<button (click)="payment()">Pay</button>-->

<!--<form novalidate (ngSubmit)="buy()" [formGroup]="stripeTest">
  <input type="text" formControlName="name" placeholder="Jane Doe">
  <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
  <button type="submit">
    BUY
  </button>
</form>-->
<!--<div>
  <form novalidate (ngSubmit)="buy()" [formGroup]="stripeTest">
    <input type="text" formControlName="name" placeholder="Name on Card">
    <div id="card-element" class="field"></div>
    <button type="submit">
      BUY
    </button>
  </form>
</div>-->

<!-- <div>
  <form action="" method="POST">
    <script
      src="https://checkout.stripe.com/checkout.js" class="stripe-button"
      data-key="pk_test_PEfNqLj0cgu6mRflQPo81oVq"
      data-image="/path/to/your/logo.png"
      data-name="Your Website Name"
      data-panel-label="Update Card Details"
      data-label="Update Card Details"
      data-allow-remember-me=false
      data-locale="auto">
    </script>
  </form>
</div>-->

<!--<script src="https://js.stripe.com/v3/"></script>



<form ngForm (submit)="submit()" id="payment-form">
  <div class="form-row">
    <label for="card-element">
      Credit or debit card
    </label>
    <div id="card-element">
      &lt;!&ndash; A Stripe Element will be inserted here. &ndash;&gt;
    </div>

    &lt;!&ndash; Used to display form errors. &ndash;&gt;
    <div id="card-errors" role="alert"></div>
  </div>

  <button>Submit Payment</button>
</form>-->
